import React from 'react'
import { useWeb3React } from 'lib/wagmi-compat/useWeb3React'
import { ContentCard, Flex, Text, TextVariant, Button, VerifiedIcon } from '@mprolab/uikit'
import styled, { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useIsUserVerified } from 'state/user/hooks'
import { useVerify } from 'state/user/hooks/useVerifyUser'
import { useAwaitingVerificationModal } from 'components/widgets/VerificationModals'

const Panel = styled(ContentCard)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px 24px;
  text-align: center;
  max-width: 560px;
  margin: 0 auto;
`

/**
 * Shown when the wallet is connected but app session (wallet-auth /me) is missing — same idea as Vesting: stay on the route, prompt sign-in.
 */
const AppSessionRequiredPanel: React.FC = () => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const { account } = useWeb3React()
  const isAppVerified = useIsUserVerified()
  const { verifyUser } = useVerify()
  const { onPresentAwaitingVerificationModal, onModalClose } = useAwaitingVerificationModal({})

  if (!account || isAppVerified) return null

  const handleSignIn = async () => {
    onPresentAwaitingVerificationModal()
    await verifyUser({
      onSuccessCallback: () => onModalClose(),
      onErrorCallback: () => onModalClose()
    })
  }

  return (
    <Panel>
      <Text variant={TextVariant.H5}>{t('protectedPages.appSignInTitle')}</Text>
      <Text variant={TextVariant.BODY_DEFAULT} color={colors.gray6}>
        {t('protectedPages.appSignInDescription')}
      </Text>
      <Button
        onClick={() => void handleSignIn()}
        endIcon={<VerifiedIcon fill={colors.white} stroke={colors.gray7} />}
      >
        {t('protectedPages.appSignInCta')}
      </Button>
    </Panel>
  )
}

export default AppSessionRequiredPanel
